import script from "./Column.vue?vue&type=script&setup=true&lang=js"
export * from "./Column.vue?vue&type=script&setup=true&lang=js"

import "./Column.vue?vue&type=style&index=0&id=1878fcb1&lang=scss&scoped=true"

import exportComponent from "/media/dolar/office/office_project/barmm-admin-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1878fcb1"]])

export default __exports__